<template>
  <router-view />
</template>

<script setup>
import { useFavicon } from '@vueuse/core'
import faviconService from '@/services/faviconService.js'
import { onMounted } from 'vue'

// Set favicon using VueUse (reactive approach) - now properly using the variable
const favicon = useFavicon('/logo-square.png')

// Also use our custom service for extra compatibility
onMounted(() => {
  faviconService.init()

  // Force update after a short delay to ensure DOM is ready
  setTimeout(() => {
    faviconService.setFavicon('/logo-square.png')

    // Log the favicon for debugging
    console.log('🎯 Favicon set via VueUse:', favicon.value)
  }, 100)
})
</script>

<style lang="scss">

  html{
    background-image: linear-gradient(to top left, #e9edff, #f5f5f5);
    height: 100vh;
    overflow: hidden;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

</style>
